@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_069_842_529)
public val Res.string.checklists_tab_templates: StringResource by lazy {
      StringResource("string:checklists_tab_templates", "checklists_tab_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61551, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85879, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54010, 44),
      ))
    }

@delegate:ResourceContentHash(2_082_953_259)
public val Res.string.checklists_templates_empty: StringResource by lazy {
      StringResource("string:checklists_templates_empty", "checklists_templates_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61596, 170),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85932, 250),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54055, 146),
      ))
    }

@delegate:ResourceContentHash(-917_620_120)
public val Res.string.checklists_title: StringResource by lazy {
      StringResource("string:checklists_title", "checklists_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61767, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86183, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54202, 40),
      ))
    }

@delegate:ResourceContentHash(517_043_591)
public val Res.string.checklists_today: StringResource by lazy {
      StringResource("string:checklists_today", "checklists_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61808, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86232, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54243, 32),
      ))
    }

@delegate:ResourceContentHash(-1_378_176_064)
public val Res.string.children_label: StringResource by lazy {
      StringResource("string:children_label", "children_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61841, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86281, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54276, 50),
      ))
    }

@delegate:ResourceContentHash(617_245_348)
public val Res.string.claim_assigned: StringResource by lazy {
      StringResource("string:claim_assigned", "claim_assigned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61924, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86416, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54327, 50),
      ))
    }

@delegate:ResourceContentHash(-1_217_821_185)
public val Res.string.claim_pending: StringResource by lazy {
      StringResource("string:claim_pending", "claim_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61971, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86467, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54378, 77),
      ))
    }

@delegate:ResourceContentHash(864_545_099)
public val Res.string.claim_refused_not_available: StringResource by lazy {
      StringResource("string:claim_refused_not_available", "claim_refused_not_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62057, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86597, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54456, 123),
      ))
    }

@delegate:ResourceContentHash(485_161_022)
public val Res.string.claim_refused_overlap: StringResource by lazy {
      StringResource("string:claim_refused_overlap", "claim_refused_overlap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62189, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86765, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54580, 69),
      ))
    }

@delegate:ResourceContentHash(-471_777_777)
public val Res.string.claim_refused_own: StringResource by lazy {
      StringResource("string:claim_refused_own", "claim_refused_own", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62271, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86875, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54650, 57),
      ))
    }

@delegate:ResourceContentHash(-1_193_834_607)
public val Res.string.clock_already_done: StringResource by lazy {
      StringResource("string:clock_already_done", "clock_already_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62329, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 86953, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54708, 78),
      ))
    }

@delegate:ResourceContentHash(-833_488_190)
public val Res.string.clock_already_in: StringResource by lazy {
      StringResource("string:clock_already_in", "clock_already_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62420, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87072, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54787, 60),
      ))
    }

@delegate:ResourceContentHash(-928_281_492)
public val Res.string.clock_already_on_break: StringResource by lazy {
      StringResource("string:clock_already_on_break", "clock_already_on_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62505, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87181, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54848, 66),
      ))
    }

@delegate:ResourceContentHash(-97_765_076)
public val Res.string.clock_done: StringResource by lazy {
      StringResource("string:clock_done", "clock_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62593, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87297, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54948, 42),
      ))
    }

@delegate:ResourceContentHash(1_584_932_036)
public val Res.string.clock_done_label: StringResource by lazy {
      StringResource("string:clock_done_label", "clock_done_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62560, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87256, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54915, 32),
      ))
    }

@delegate:ResourceContentHash(560_871_953)
public val Res.string.clock_flag_outside: StringResource by lazy {
      StringResource("string:clock_flag_outside", "clock_flag_outside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62648, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87368, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54991, 130),
      ))
    }

@delegate:ResourceContentHash(267_652_993)
public val Res.string.clock_flag_unverified: StringResource by lazy {
      StringResource("string:clock_flag_unverified", "clock_flag_unverified", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62791, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87583, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55122, 117),
      ))
    }

@delegate:ResourceContentHash(-145_900_528)
public val Res.string.clock_idle: StringResource by lazy {
      StringResource("string:clock_idle", "clock_idle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62913, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87781, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55240, 46),
      ))
    }

@delegate:ResourceContentHash(54_070_123)
public val Res.string.clock_location_denied: StringResource by lazy {
      StringResource("string:clock_location_denied", "clock_location_denied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 62968, 245),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 87888, 421),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55287, 213),
      ))
    }

@delegate:ResourceContentHash(1_111_913_620)
public val Res.string.clock_location_no_fix: StringResource by lazy {
      StringResource("string:clock_location_no_fix", "clock_location_no_fix", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63214, 173),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 88310, 297),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55501, 161),
      ))
    }

@delegate:ResourceContentHash(1_286_635_840)
public val Res.string.clock_location_unsupported: StringResource by lazy {
      StringResource("string:clock_location_unsupported", "clock_location_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63388, 202),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 88608, 354),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55663, 194),
      ))
    }

@delegate:ResourceContentHash(-832_991_480)
public val Res.string.clock_no_shift_now: StringResource by lazy {
      StringResource("string:clock_no_shift_now", "clock_no_shift_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63591, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 88963, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55858, 70),
      ))
    }

@delegate:ResourceContentHash(-980_330_877)
public val Res.string.clock_not_in: StringResource by lazy {
      StringResource("string:clock_not_in", "clock_not_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63694, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89090, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55929, 72),
      ))
    }

@delegate:ResourceContentHash(1_718_286_193)
public val Res.string.clock_not_on_break: StringResource by lazy {
      StringResource("string:clock_not_on_break", "clock_not_on_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63779, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89191, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56002, 58),
      ))
    }

@delegate:ResourceContentHash(-2_041_151_326)
public val Res.string.clock_not_yours: StringResource by lazy {
      StringResource("string:clock_not_yours", "clock_not_yours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63838, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89274, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56061, 55),
      ))
    }

@delegate:ResourceContentHash(-550_211_408)
public val Res.string.clock_on_break_since: StringResource by lazy {
      StringResource("string:clock_on_break_since", "clock_on_break_since", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63898, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89338, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56117, 56),
      ))
    }

@delegate:ResourceContentHash(-1_957_954_732)
public val Res.string.clock_out: StringResource by lazy {
      StringResource("string:clock_out", "clock_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64359, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89967, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56522, 29),
      ))
    }

@delegate:ResourceContentHash(680_065_656)
public val Res.string.clock_out_done: StringResource by lazy {
      StringResource("string:clock_out_done", "clock_out_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 63955, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89403, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56174, 38),
      ))
    }

@delegate:ResourceContentHash(153_700_168)
public val Res.string.clock_out_early_text: StringResource by lazy {
      StringResource("string:clock_out_early_text", "clock_out_early_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64002, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89470, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56213, 72),
      ))
    }

@delegate:ResourceContentHash(774_723_718)
public val Res.string.clock_out_early_title: StringResource by lazy {
      StringResource("string:clock_out_early_title", "clock_out_early_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64095, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89615, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56286, 53),
      ))
    }

@delegate:ResourceContentHash(-2_045_529_377)
public val Res.string.clock_out_keep_working: StringResource by lazy {
      StringResource("string:clock_out_keep_working", "clock_out_keep_working", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64165, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89705, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56340, 46),
      ))
    }

@delegate:ResourceContentHash(-1_101_498_947)
public val Res.string.clock_outside_area: StringResource by lazy {
      StringResource("string:clock_outside_area", "clock_outside_area", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64216, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 89772, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56387, 134),
      ))
    }

@delegate:ResourceContentHash(838_767_004)
public val Res.string.clock_review_adjust: StringResource by lazy {
      StringResource("string:clock_review_adjust", "clock_review_adjust", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64397, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90029, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56552, 47),
      ))
    }

@delegate:ResourceContentHash(-860_746_421)
public val Res.string.clock_review_approve: StringResource by lazy {
      StringResource("string:clock_review_approve", "clock_review_approve", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64449, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90105, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56600, 48),
      ))
    }

@delegate:ResourceContentHash(-1_788_467_174)
public val Res.string.clock_review_clocked: StringResource by lazy {
      StringResource("string:clock_review_clocked", "clock_review_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64558, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90222, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56701, 56),
      ))
    }

@delegate:ResourceContentHash(-1_135_296_310)
public val Res.string.clock_review_clocked_in: StringResource by lazy {
      StringResource("string:clock_review_clocked_in", "clock_review_clocked_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64506, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90166, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56649, 51),
      ))
    }

@delegate:ResourceContentHash(168_122_983)
public val Res.string.clock_review_confirm: StringResource by lazy {
      StringResource("string:clock_review_confirm", "clock_review_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64623, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90303, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56758, 40),
      ))
    }

@delegate:ResourceContentHash(514_357_817)
public val Res.string.clock_review_count: StringResource by lazy {
      StringResource("string:clock_review_count", "clock_review_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64668, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90364, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56799, 46),
      ))
    }

@delegate:ResourceContentHash(1_990_520_337)
public val Res.string.clock_review_done_adjusted: StringResource by lazy {
      StringResource("string:clock_review_done_adjusted", "clock_review_done_adjusted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64723, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90431, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56846, 66),
      ))
    }

@delegate:ResourceContentHash(1_642_545_824)
public val Res.string.clock_review_done_approved: StringResource by lazy {
      StringResource("string:clock_review_done_approved", "clock_review_done_approved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64798, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90530, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56913, 46),
      ))
    }

@delegate:ResourceContentHash(200_537_876)
public val Res.string.clock_review_done_confirmed: StringResource by lazy {
      StringResource("string:clock_review_done_confirmed", "clock_review_done_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64853, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90589, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56960, 119),
      ))
    }

@delegate:ResourceContentHash(499_681_316)
public val Res.string.clock_review_done_edited: StringResource by lazy {
      StringResource("string:clock_review_done_edited", "clock_review_done_edited", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 64981, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90785, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57080, 48),
      ))
    }

@delegate:ResourceContentHash(-1_164_315_337)
public val Res.string.clock_review_done_rejected: StringResource by lazy {
      StringResource("string:clock_review_done_rejected", "clock_review_done_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65038, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90854, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57129, 46),
      ))
    }

@delegate:ResourceContentHash(-1_205_077_578)
public val Res.string.clock_review_edit: StringResource by lazy {
      StringResource("string:clock_review_edit", "clock_review_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65353, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91285, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57444, 41),
      ))
    }

@delegate:ResourceContentHash(779_867_892)
public val Res.string.clock_review_edit_end: StringResource by lazy {
      StringResource("string:clock_review_edit_end", "clock_review_edit_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65089, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 90917, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57176, 89),
      ))
    }

@delegate:ResourceContentHash(-665_103_266)
public val Res.string.clock_review_edit_invalid: StringResource by lazy {
      StringResource("string:clock_review_edit_invalid", "clock_review_edit_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65179, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91051, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57266, 121),
      ))
    }

@delegate:ResourceContentHash(2_116_148_831)
public val Res.string.clock_review_edit_start: StringResource by lazy {
      StringResource("string:clock_review_edit_start", "clock_review_edit_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65297, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91221, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57388, 55),
      ))
    }

@delegate:ResourceContentHash(931_265_896)
public val Res.string.clock_review_empty: StringResource by lazy {
      StringResource("string:clock_review_empty", "clock_review_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65399, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91339, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57486, 50),
      ))
    }

@delegate:ResourceContentHash(-673_987_413)
public val Res.string.clock_review_error_decided: StringResource by lazy {
      StringResource("string:clock_review_error_decided", "clock_review_error_decided", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65462, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91430, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57537, 82),
      ))
    }

@delegate:ResourceContentHash(1_146_042_847)
public val Res.string.clock_review_error_no_plan: StringResource by lazy {
      StringResource("string:clock_review_error_no_plan", "clock_review_error_no_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65537, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91557, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57620, 78),
      ))
    }

@delegate:ResourceContentHash(261_226_699)
public val Res.string.clock_review_error_not_clocked: StringResource by lazy {
      StringResource("string:clock_review_error_not_clocked", "clock_review_error_not_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65620, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91688, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57699, 82),
      ))
    }

@delegate:ResourceContentHash(-2_140_220_434)
public val Res.string.clock_review_error_plan_ended: StringResource by lazy {
      StringResource("string:clock_review_error_plan_ended", "clock_review_error_plan_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65715, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91811, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57782, 117),
      ))
    }

@delegate:ResourceContentHash(-641_848_052)
public val Res.string.clock_review_extra_minutes: StringResource by lazy {
      StringResource("string:clock_review_extra_minutes", "clock_review_extra_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65821, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 91985, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57900, 90),
      ))
    }

@delegate:ResourceContentHash(226_288_120)
public val Res.string.clock_review_flag_clock_drift: StringResource by lazy {
      StringResource("string:clock_review_flag_clock_drift", "clock_review_flag_clock_drift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 65920, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92116, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57991, 85),
      ))
    }

@delegate:ResourceContentHash(1_845_706_584)
public val Res.string.clock_review_flag_early_in: StringResource by lazy {
      StringResource("string:clock_review_flag_early_in", "clock_review_flag_early_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66018, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92262, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58077, 58),
      ))
    }

@delegate:ResourceContentHash(-1_308_801_675)
public val Res.string.clock_review_flag_late_out: StringResource by lazy {
      StringResource("string:clock_review_flag_late_out", "clock_review_flag_late_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66097, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92333, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58136, 58),
      ))
    }

@delegate:ResourceContentHash(1_120_215_862)
public val Res.string.clock_review_flag_no_app_activity: StringResource by lazy {
      StringResource("string:clock_review_flag_no_app_activity", "clock_review_flag_no_app_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66176, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92400, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58195, 85),
      ))
    }

@delegate:ResourceContentHash(-1_969_366_835)
public val Res.string.clock_review_flag_outside_area: StringResource by lazy {
      StringResource("string:clock_review_flag_outside_area", "clock_review_flag_outside_area", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66278, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92538, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58281, 74),
      ))
    }

@delegate:ResourceContentHash(-580_411_876)
public val Res.string.clock_review_flag_overrun: StringResource by lazy {
      StringResource("string:clock_review_flag_overrun", "clock_review_flag_overrun", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66345, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92637, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58356, 61),
      ))
    }

@delegate:ResourceContentHash(-942_079_177)
public val Res.string.clock_review_flag_same_tablet: StringResource by lazy {
      StringResource("string:clock_review_flag_same_tablet", "clock_review_flag_same_tablet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66411, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92719, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58418, 89),
      ))
    }

@delegate:ResourceContentHash(998_108_938)
public val Res.string.clock_review_flag_very_short: StringResource by lazy {
      StringResource("string:clock_review_flag_very_short", "clock_review_flag_very_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66509, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92861, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58508, 60),
      ))
    }

@delegate:ResourceContentHash(-818_576_108)
public val Res.string.clock_review_photo: StringResource by lazy {
      StringResource("string:clock_review_photo", "clock_review_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66866, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93294, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58805, 34),
      ))
    }

@delegate:ResourceContentHash(-1_940_835_190)
public val Res.string.clock_review_photo_missing: StringResource by lazy {
      StringResource("string:clock_review_photo_missing", "clock_review_photo_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66574, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 92946, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58569, 86),
      ))
    }

@delegate:ResourceContentHash(-1_741_568_954)
public val Res.string.clock_review_photo_note: StringResource by lazy {
      StringResource("string:clock_review_photo_note", "clock_review_photo_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66677, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93069, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58656, 95),
      ))
    }

@delegate:ResourceContentHash(-43_568_054)
public val Res.string.clock_review_photo_title: StringResource by lazy {
      StringResource("string:clock_review_photo_title", "clock_review_photo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66789, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93209, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58752, 52),
      ))
    }

@delegate:ResourceContentHash(-1_867_696_022)
public val Res.string.clock_review_planned: StringResource by lazy {
      StringResource("string:clock_review_planned", "clock_review_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66905, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93333, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58840, 56),
      ))
    }

@delegate:ResourceContentHash(1_891_771_094)
public val Res.string.clock_review_reject: StringResource by lazy {
      StringResource("string:clock_review_reject", "clock_review_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66962, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93390, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58897, 35),
      ))
    }

@delegate:ResourceContentHash(-1_371_239_595)
public val Res.string.clock_review_title: StringResource by lazy {
      StringResource("string:clock_review_title", "clock_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67002, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93442, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58933, 38),
      ))
    }

@delegate:ResourceContentHash(627_696_920)
public val Res.string.clock_review_unplanned_cover: StringResource by lazy {
      StringResource("string:clock_review_unplanned_cover", "clock_review_unplanned_cover", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67049, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93501, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58972, 92),
      ))
    }

@delegate:ResourceContentHash(-1_222_548_889)
public val Res.string.clock_review_unplanned_extra: StringResource by lazy {
      StringResource("string:clock_review_unplanned_extra", "clock_review_unplanned_extra", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67158, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93622, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59065, 96),
      ))
    }

@delegate:ResourceContentHash(-15_984_703)
public val Res.string.clock_shift_window: StringResource by lazy {
      StringResource("string:clock_shift_window", "clock_shift_window", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67267, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93783, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59162, 50),
      ))
    }

@delegate:ResourceContentHash(-71_015_889)
public val Res.string.clock_too_early: StringResource by lazy {
      StringResource("string:clock_too_early", "clock_too_early", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67318, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 93842, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59213, 87),
      ))
    }

@delegate:ResourceContentHash(-1_639_075_136)
public val Res.string.clock_too_many_breaks: StringResource by lazy {
      StringResource("string:clock_too_many_breaks", "clock_too_many_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67430, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 94014, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59301, 93),
      ))
    }

@delegate:ResourceContentHash(-178_349_026)
public val Res.string.clock_undo_too_late: StringResource by lazy {
      StringResource("string:clock_undo_too_late", "clock_undo_too_late", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67536, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 94160, 219),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59395, 127),
      ))
    }

@delegate:ResourceContentHash(1_432_118_256)
public val Res.string.clock_unplanned_cover_done: StringResource by lazy {
      StringResource("string:clock_unplanned_cover_done", "clock_unplanned_cover_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67688, 138),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 94380, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59523, 106),
      ))
    }

@delegate:ResourceContentHash(-1_896_641_796)
public val Res.string.clock_unplanned_extra_done: StringResource by lazy {
      StringResource("string:clock_unplanned_extra_done", "clock_unplanned_extra_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67827, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 94539, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59630, 114),
      ))
    }

@delegate:ResourceContentHash(708_385_789)
public val Res.string.clock_without_shift: StringResource by lazy {
      StringResource("string:clock_without_shift", "clock_without_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68092, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 94912, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59867, 75),
      ))
    }

@delegate:ResourceContentHash(-1_875_360_709)
public val Res.string.clock_without_shift_explained: StringResource by lazy {
      StringResource("string:clock_without_shift_explained", "clock_without_shift_explained", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 67958, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 94726, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59745, 121),
      ))
    }

@delegate:ResourceContentHash(-1_087_012_780)
public val Res.string.clock_working_since: StringResource by lazy {
      StringResource("string:clock_working_since", "clock_working_since", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68172, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95024, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59943, 51),
      ))
    }

@delegate:ResourceContentHash(494_896_124)
public val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68220, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95088, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59995, 21),
      ))
    }

@delegate:ResourceContentHash(2_030_317_957)
public val Res.string.comparison_base: StringResource by lazy {
      StringResource("string:comparison_base", "comparison_base", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68246, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95122, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60017, 39),
      ))
    }

@delegate:ResourceContentHash(-1_543_343_099)
public val Res.string.comparison_change: StringResource by lazy {
      StringResource("string:comparison_change", "comparison_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68286, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95174, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60057, 33),
      ))
    }

@delegate:ResourceContentHash(444_416_594)
public val Res.string.comparison_chart_description: StringResource by lazy {
      StringResource("string:comparison_chart_description", "comparison_chart_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68320, 152),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95216, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60091, 124),
      ))
    }

@delegate:ResourceContentHash(-2_096_547_885)
public val Res.string.comparison_difference: StringResource by lazy {
      StringResource("string:comparison_difference", "comparison_difference", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68473, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95437, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60216, 45),
      ))
    }

@delegate:ResourceContentHash(-994_738_569)
public val Res.string.comparison_fall: StringResource by lazy {
      StringResource("string:comparison_fall", "comparison_fall", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68515, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95487, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60262, 31),
      ))
    }

@delegate:ResourceContentHash(-1_270_214_065)
public val Res.string.comparison_holiday: StringResource by lazy {
      StringResource("string:comparison_holiday", "comparison_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68763, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95815, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60506, 38),
      ))
    }

@delegate:ResourceContentHash(334_603_046)
public val Res.string.comparison_holiday_now: StringResource by lazy {
      StringResource("string:comparison_holiday_now", "comparison_holiday_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68547, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95535, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60294, 58),
      ))
    }

@delegate:ResourceContentHash(2_025_200_023)
public val Res.string.comparison_holiday_then: StringResource by lazy {
      StringResource("string:comparison_holiday_then", "comparison_holiday_then", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68606, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95606, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60353, 67),
      ))
    }

@delegate:ResourceContentHash(743_534_555)
public val Res.string.comparison_holidays_note: StringResource by lazy {
      StringResource("string:comparison_holidays_note", "comparison_holidays_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68674, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95698, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60421, 84),
      ))
    }

@delegate:ResourceContentHash(1_049_542_914)
public val Res.string.comparison_like_for_like: StringResource by lazy {
      StringResource("string:comparison_like_for_like", "comparison_like_for_like", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68802, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 95858, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60545, 100),
      ))
    }

@delegate:ResourceContentHash(-992_286_326)
public val Res.string.comparison_loading: StringResource by lazy {
      StringResource("string:comparison_loading", "comparison_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68907, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96003, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60646, 62),
      ))
    }

@delegate:ResourceContentHash(-1_075_520_587)
public val Res.string.comparison_metric_labour: StringResource by lazy {
      StringResource("string:comparison_metric_labour", "comparison_metric_labour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 68970, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96094, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60709, 48),
      ))
    }

@delegate:ResourceContentHash(-1_223_248_724)
public val Res.string.comparison_metric_result: StringResource by lazy {
      StringResource("string:comparison_metric_result", "comparison_metric_result", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69035, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96183, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60758, 40),
      ))
    }

@delegate:ResourceContentHash(-2_101_537_836)
public val Res.string.comparison_metric_sales: StringResource by lazy {
      StringResource("string:comparison_metric_sales", "comparison_metric_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69076, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96240, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60799, 43),
      ))
    }

@delegate:ResourceContentHash(-779_601_736)
public val Res.string.comparison_mode_last_week: StringResource by lazy {
      StringResource("string:comparison_mode_last_week", "comparison_mode_last_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69128, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96308, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60843, 45),
      ))
    }

@delegate:ResourceContentHash(162_620_399)
public val Res.string.comparison_mode_last_year_date: StringResource by lazy {
      StringResource("string:comparison_mode_last_year_date", "comparison_mode_last_year_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69186, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96382, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60889, 62),
      ))
    }

@delegate:ResourceContentHash(772_349_958)
public val Res.string.comparison_mode_last_year_weekday: StringResource by lazy {
      StringResource("string:comparison_mode_last_year_weekday", "comparison_mode_last_year_weekday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69245, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96465, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60952, 69),
      ))
    }

@delegate:ResourceContentHash(-3_814_567)
public val Res.string.comparison_month_to_date: StringResource by lazy {
      StringResource("string:comparison_month_to_date", "comparison_month_to_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69323, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96567, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61022, 52),
      ))
    }

@delegate:ResourceContentHash(-2_111_956_907)
public val Res.string.comparison_no_data: StringResource by lazy {
      StringResource("string:comparison_no_data", "comparison_no_data", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69380, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96648, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61075, 38),
      ))
    }

@delegate:ResourceContentHash(-156_186_502)
public val Res.string.comparison_no_last_week: StringResource by lazy {
      StringResource("string:comparison_no_last_week", "comparison_no_last_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69423, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96703, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61114, 63),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString7Resources(map: MutableMap<String, StringResource>) {
  map.put("checklists_tab_templates", Res.string.checklists_tab_templates)
  map.put("checklists_templates_empty", Res.string.checklists_templates_empty)
  map.put("checklists_title", Res.string.checklists_title)
  map.put("checklists_today", Res.string.checklists_today)
  map.put("children_label", Res.string.children_label)
  map.put("claim_assigned", Res.string.claim_assigned)
  map.put("claim_pending", Res.string.claim_pending)
  map.put("claim_refused_not_available", Res.string.claim_refused_not_available)
  map.put("claim_refused_overlap", Res.string.claim_refused_overlap)
  map.put("claim_refused_own", Res.string.claim_refused_own)
  map.put("clock_already_done", Res.string.clock_already_done)
  map.put("clock_already_in", Res.string.clock_already_in)
  map.put("clock_already_on_break", Res.string.clock_already_on_break)
  map.put("clock_done", Res.string.clock_done)
  map.put("clock_done_label", Res.string.clock_done_label)
  map.put("clock_flag_outside", Res.string.clock_flag_outside)
  map.put("clock_flag_unverified", Res.string.clock_flag_unverified)
  map.put("clock_idle", Res.string.clock_idle)
  map.put("clock_location_denied", Res.string.clock_location_denied)
  map.put("clock_location_no_fix", Res.string.clock_location_no_fix)
  map.put("clock_location_unsupported", Res.string.clock_location_unsupported)
  map.put("clock_no_shift_now", Res.string.clock_no_shift_now)
  map.put("clock_not_in", Res.string.clock_not_in)
  map.put("clock_not_on_break", Res.string.clock_not_on_break)
  map.put("clock_not_yours", Res.string.clock_not_yours)
  map.put("clock_on_break_since", Res.string.clock_on_break_since)
  map.put("clock_out", Res.string.clock_out)
  map.put("clock_out_done", Res.string.clock_out_done)
  map.put("clock_out_early_text", Res.string.clock_out_early_text)
  map.put("clock_out_early_title", Res.string.clock_out_early_title)
  map.put("clock_out_keep_working", Res.string.clock_out_keep_working)
  map.put("clock_outside_area", Res.string.clock_outside_area)
  map.put("clock_review_adjust", Res.string.clock_review_adjust)
  map.put("clock_review_approve", Res.string.clock_review_approve)
  map.put("clock_review_clocked", Res.string.clock_review_clocked)
  map.put("clock_review_clocked_in", Res.string.clock_review_clocked_in)
  map.put("clock_review_confirm", Res.string.clock_review_confirm)
  map.put("clock_review_count", Res.string.clock_review_count)
  map.put("clock_review_done_adjusted", Res.string.clock_review_done_adjusted)
  map.put("clock_review_done_approved", Res.string.clock_review_done_approved)
  map.put("clock_review_done_confirmed", Res.string.clock_review_done_confirmed)
  map.put("clock_review_done_edited", Res.string.clock_review_done_edited)
  map.put("clock_review_done_rejected", Res.string.clock_review_done_rejected)
  map.put("clock_review_edit", Res.string.clock_review_edit)
  map.put("clock_review_edit_end", Res.string.clock_review_edit_end)
  map.put("clock_review_edit_invalid", Res.string.clock_review_edit_invalid)
  map.put("clock_review_edit_start", Res.string.clock_review_edit_start)
  map.put("clock_review_empty", Res.string.clock_review_empty)
  map.put("clock_review_error_decided", Res.string.clock_review_error_decided)
  map.put("clock_review_error_no_plan", Res.string.clock_review_error_no_plan)
  map.put("clock_review_error_not_clocked", Res.string.clock_review_error_not_clocked)
  map.put("clock_review_error_plan_ended", Res.string.clock_review_error_plan_ended)
  map.put("clock_review_extra_minutes", Res.string.clock_review_extra_minutes)
  map.put("clock_review_flag_clock_drift", Res.string.clock_review_flag_clock_drift)
  map.put("clock_review_flag_early_in", Res.string.clock_review_flag_early_in)
  map.put("clock_review_flag_late_out", Res.string.clock_review_flag_late_out)
  map.put("clock_review_flag_no_app_activity", Res.string.clock_review_flag_no_app_activity)
  map.put("clock_review_flag_outside_area", Res.string.clock_review_flag_outside_area)
  map.put("clock_review_flag_overrun", Res.string.clock_review_flag_overrun)
  map.put("clock_review_flag_same_tablet", Res.string.clock_review_flag_same_tablet)
  map.put("clock_review_flag_very_short", Res.string.clock_review_flag_very_short)
  map.put("clock_review_photo", Res.string.clock_review_photo)
  map.put("clock_review_photo_missing", Res.string.clock_review_photo_missing)
  map.put("clock_review_photo_note", Res.string.clock_review_photo_note)
  map.put("clock_review_photo_title", Res.string.clock_review_photo_title)
  map.put("clock_review_planned", Res.string.clock_review_planned)
  map.put("clock_review_reject", Res.string.clock_review_reject)
  map.put("clock_review_title", Res.string.clock_review_title)
  map.put("clock_review_unplanned_cover", Res.string.clock_review_unplanned_cover)
  map.put("clock_review_unplanned_extra", Res.string.clock_review_unplanned_extra)
  map.put("clock_shift_window", Res.string.clock_shift_window)
  map.put("clock_too_early", Res.string.clock_too_early)
  map.put("clock_too_many_breaks", Res.string.clock_too_many_breaks)
  map.put("clock_undo_too_late", Res.string.clock_undo_too_late)
  map.put("clock_unplanned_cover_done", Res.string.clock_unplanned_cover_done)
  map.put("clock_unplanned_extra_done", Res.string.clock_unplanned_extra_done)
  map.put("clock_without_shift", Res.string.clock_without_shift)
  map.put("clock_without_shift_explained", Res.string.clock_without_shift_explained)
  map.put("clock_working_since", Res.string.clock_working_since)
  map.put("close", Res.string.close)
  map.put("comparison_base", Res.string.comparison_base)
  map.put("comparison_change", Res.string.comparison_change)
  map.put("comparison_chart_description", Res.string.comparison_chart_description)
  map.put("comparison_difference", Res.string.comparison_difference)
  map.put("comparison_fall", Res.string.comparison_fall)
  map.put("comparison_holiday", Res.string.comparison_holiday)
  map.put("comparison_holiday_now", Res.string.comparison_holiday_now)
  map.put("comparison_holiday_then", Res.string.comparison_holiday_then)
  map.put("comparison_holidays_note", Res.string.comparison_holidays_note)
  map.put("comparison_like_for_like", Res.string.comparison_like_for_like)
  map.put("comparison_loading", Res.string.comparison_loading)
  map.put("comparison_metric_labour", Res.string.comparison_metric_labour)
  map.put("comparison_metric_result", Res.string.comparison_metric_result)
  map.put("comparison_metric_sales", Res.string.comparison_metric_sales)
  map.put("comparison_mode_last_week", Res.string.comparison_mode_last_week)
  map.put("comparison_mode_last_year_date", Res.string.comparison_mode_last_year_date)
  map.put("comparison_mode_last_year_weekday", Res.string.comparison_mode_last_year_weekday)
  map.put("comparison_month_to_date", Res.string.comparison_month_to_date)
  map.put("comparison_no_data", Res.string.comparison_no_data)
  map.put("comparison_no_last_week", Res.string.comparison_no_last_week)
}
